/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterSubmissionStatsQueryDto
 */
export interface FilterSubmissionStatsQueryDto {
    /**
     * 
     * @type {string}
     * @memberof FilterSubmissionStatsQueryDto
     */
    status: FilterSubmissionStatsQueryDtoStatusEnum;
}


/**
 * @export
 */
export const FilterSubmissionStatsQueryDtoStatusEnum = {
    Prospect: 'Prospect',
    Pending: 'Pending',
    Quoted: 'Quoted',
    Declined: 'Declined',
    Cancelled: 'Cancelled',
    Complete: 'Complete'
} as const;
export type FilterSubmissionStatsQueryDtoStatusEnum = typeof FilterSubmissionStatsQueryDtoStatusEnum[keyof typeof FilterSubmissionStatsQueryDtoStatusEnum];


/**
 * Check if a given object implements the FilterSubmissionStatsQueryDto interface.
 */
export function instanceOfFilterSubmissionStatsQueryDto(value: object): value is FilterSubmissionStatsQueryDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function FilterSubmissionStatsQueryDtoFromJSON(json: any): FilterSubmissionStatsQueryDto {
    return FilterSubmissionStatsQueryDtoFromJSONTyped(json, false);
}

export function FilterSubmissionStatsQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterSubmissionStatsQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function FilterSubmissionStatsQueryDtoToJSON(json: any): FilterSubmissionStatsQueryDto {
    return FilterSubmissionStatsQueryDtoToJSONTyped(json, false);
}

export function FilterSubmissionStatsQueryDtoToJSONTyped(value?: FilterSubmissionStatsQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

